import uuidv4 from "../../tools/guidgenerator";
import * as Constants from "../../config";
import { useEffect, useState } from "react";
import AddSlide from "./add-slide";
import { useTranslation } from "react-i18next";

export default function SlidesAdmin() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();

  function getData() {
    fetch(Constants.apiurl + Constants.slides)
      .then((response) => response.json())
      .then((slides) => {
        // Если нет order, присваиваем по индексу
        const normalized = slides.map((s, i) => ({
          ...s,
          order: s.order ?? i, // если нет order, ставим индекс
        }));
        const sorted = normalized.sort((a, b) => a.order - b.order);
        setData(sorted);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  function closeWindow() {
    setModalOpened(false);
  }

  useEffect(() => {
    getData();
  }, []);

  function openModal(record) {
    if (!record) {
      record = { id: uuidv4(), order: data.length }; // новый слайд с order = конец
    }
    setSelectedRecord(record);
    setModalOpened(true);
  }

  const saveData = (record) => {
    const body = Constants.requestBody(record);
    fetch(Constants.apiurl + Constants.slides, body)
      .then((response) => {
        if (response.status === 401) window.location.reload(false);
        return response.json();
      })
      .then(() => {
        getData();
      })
      .catch((err) => {
        console.log(err.error);
      });
  };

  const deleteRecord = (id) => {
    fetch(Constants.apiurl + Constants.deleteslide + "?id=" + id, Constants.requestHeaderOnly())
      .then(() => {
        getData();
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // 🔥 Обновление order в базе только для двух элементов
  const updateOrderOnServer = (slide1, slide2) => {
    saveData(slide1);
    saveData(slide2);
  };

  const swapSlides = (index1, index2) => {
    const newData = [...data];
    const slide1 = { ...newData[index1] };
    const slide2 = { ...newData[index2] };

    // Если нет order, присвоим текущий индекс
    slide1.order = slide1.order ?? index1;
    slide2.order = slide2.order ?? index2;

    // Меняем местами order
    const tempOrder = slide1.order;
    slide1.order = slide2.order;
    slide2.order = tempOrder;

    // Обновляем массив
    newData[index1] = slide2;
    newData[index2] = slide1;

    setData(newData);

    // Обновляем на сервере
    updateOrderOnServer(slide1, slide2);
  };

  const moveUp = (index) => {
    if (index === 0) return;
    swapSlides(index, index - 1);
  };

  const moveDown = (index) => {
    if (index === data.length - 1) return;
    swapSlides(index, index + 1);
  };

  return (
    <>
      {modalOpened ? (
        <AddSlide record={selectedRecord} saveRecord={saveData} closeWindow={closeWindow} />
      ) : null}
      <h2>Slides</h2>
      <div onClick={() => openModal(undefined)} className="add-button">
        {t("Ajouter")}
      </div>
      <table id="reviews-table">
        <thead>
          <tr>
            <th>Order</th>
            <th>Title</th>
            <th>Text</th>
          </tr>
        </thead>
        <tbody>
          {data.map((x, index) => (
            <tr key={x.id}>
              <td id="slides-order">
                <img
                  src="up-arrow.svg"
                  onClick={() => moveUp(index)}
                  style={{ cursor: "pointer" }}
                />
                <img
                  src="down-arrow.svg"
                  onClick={() => moveDown(index)}
                  style={{ cursor: "pointer" }}
                />
              </td>
              <td>{x.title}</td>
              <td>{x.text}</td>
              <td id="buttons">
                <div onClick={() => openModal(x)} className="edit-button">
                  {t("Editer")}
                </div>
                <div onClick={() => deleteRecord(x.id)} className="delete-button">
                  {t("Supprimer")}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
